"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalRouterLink = exports.InternalLink = exports.ExternalLink = exports.Emphasis = void 0;
exports.Message = Message;
exports.TagClass = exports.Sup = exports.Stronger = exports.Strong = exports.SpanClass = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _messageInjector = _interopRequireDefault(require("./message-injector"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable prefer-const */
/* eslint-disable react/no-multi-comp */
/*
	Allows us to use a simplified form of Markdown to inject variables and components into a react Fragment.

	Usage:

	<Message
		text="All {1} Applicants selected.  [Only select the {2} on this page]"
		params={[totalApplicants, pageApplicants]}
		link={InternalLink("","js-check-all-on-page")}
		em={Emphasis}
		strong={Strong}
	/>

	[text] wraps a link.  The wrapping closure can be replaced with the "link" property.  Prexisting closures exist for
	InternalLink(href,className) and ExternalLink(href,className).
	_text    or *text*   wraps em.   The wrapping closure can be modified witht he "em" property. The default is <em></em>
	__text__ or **text** wraps strong.  The default wrapper can be modified with the "strong" property.  The default is <strong></strong>

	A linefeed is automatically converted to a <br />

*/

function linebreakInserter(str) {
  let ret = [];
  let arr = (str + '').split('\n');
  for (let i = 0; i < arr.length; ++i) {
    if (i > 0) {
      ret.push( /*#__PURE__*/_react.default.createElement("br", {
        key: `message-linebreak-${i}`
      }));
    }
    ret.push(arr[i]);
  }
  if (ret.length === 1) {
    return ret[0];
  }
  return ret;
}
function buildWrap(settings = {}, defaults) {
  if ((0, _isFunction2.default)(settings)) {
    return settings;
  }
  let i;
  for (i in defaults) {
    settings[i] = settings[i] || defaults[i];
  }
  let props = {};
  for (i in settings) {
    if (i === 'extra' && settings[i] === 'externalLink') {
      props.rel = 'noopener noreferrer';
      props.target = '_blank';
    } else if (i !== 'tag') {
      props[i] = settings[i];
    }
  }
  return function (inner) {
    return /*#__PURE__*/(0, _react.createElement)(settings.tag, props, inner);
  };
}
function Message(props) {
  const {
    em,
    link,
    params,
    strong,
    text
  } = props;
  let wraps = {
    em: Emphasis,
    strong: Strong,
    link: inner => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, "[", inner, "]") // This is just a dummy wrapper that leaves [] unchanged.
  };

  wraps.em = buildWrap(em, {
    tag: 'em'
  });
  wraps.strong = buildWrap(strong, {
    tag: 'strong'
  });
  wraps.link = buildWrap(link, {
    tag: 'a'
  });
  for (let i = 1; i <= 9; ++i) {
    wraps['link' + i] = buildWrap(props['link' + i], {
      tag: 'a'
    });
  }
  let injector = new _messageInjector.default(params, wraps, linebreakInserter);
  const elements = injector.getElements(text);
  return (0, _reduce.default)(elements).call(elements, (acc, curItem) => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, acc, curItem));
}
const Sup = inner => /*#__PURE__*/_react.default.createElement("sup", null, inner);
exports.Sup = Sup;
const TagClass = (tag, className = {}) => inner => /*#__PURE__*/(0, _react.createElement)(tag, {
  className
}, inner);
exports.TagClass = TagClass;
const SpanClass = (className = {}) => inner => /*#__PURE__*/_react.default.createElement("span", {
  className: className
}, inner);
exports.SpanClass = SpanClass;
const ExternalLink = (href, className = {}) => {
  return inner => /*#__PURE__*/_react.default.createElement("a", {
    className: className,
    href: href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, inner);
};
exports.ExternalLink = ExternalLink;
const InternalLink = (href, className = {}) => inner => /*#__PURE__*/_react.default.createElement("a", {
  className: className,
  href: href
}, inner);
exports.InternalLink = InternalLink;
const InternalRouterLink = (href, className = {}) => inner => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
  className: className,
  to: href
}, inner);
exports.InternalRouterLink = InternalRouterLink;
const Emphasis = inner => /*#__PURE__*/_react.default.createElement("em", null, inner);
exports.Emphasis = Emphasis;
const Strong = inner => /*#__PURE__*/_react.default.createElement("strong", null, inner);
exports.Strong = Strong;
const Stronger = inner => /*#__PURE__*/_react.default.createElement("span", {
  style: {
    fontWeight: 700
  }
}, inner);
exports.Stronger = Stronger;